import { Stack, Table, TableBody, TableContainer, TableRow } from '@mui/material'
import { IEFDetailTableProps, IEFDetailTableRowProps } from './EFLabeledContent.model'
import { currentTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { EFTableCell } from '../EFTable'
import { EFDuplicateIcon, EFEmptyIcon, EFPendingIcon } from '../EFIcons'

export function EFDetailTableRow({
  label,
  value,
  isHighlightKey,
  labelCellProps,
  valueCellProps,
  noneBorder,
  isDuplicate,
  isEmpty,
  isModified,
  ...props
}: IEFDetailTableRowProps) {
  const theme = useAppSelector(currentTheme)
  const keyCellClass = isHighlightKey ? 'keyTableCell' : noneBorder && 'border-0'
  const valueCellClass = isHighlightKey ? 'valueTableCell' : noneBorder && 'border-0'

  return (
    <TableRow {...props}>
      <EFTableCell
        width='20%'
        {...labelCellProps}
        className={`table-cell ${theme} ${keyCellClass} ${labelCellProps?.className}`}
      >
        <Stack direction='row'>
          {label}
          {isDuplicate && (
            <div
              title='Value is not unique'
              className='small-icon'
            >
              <EFDuplicateIcon />
            </div>
          )}
          {isEmpty && (
            <div
              title='Value is empty'
              className='small-icon'
            >
              <EFEmptyIcon />
            </div>
          )}
          {isModified && (
            <div
              title='Value is modified'
              className='small-icon'
            >
              <EFPendingIcon />
            </div>
          )}
        </Stack>
      </EFTableCell>
      {Array.isArray(value) ? (
        value.map((item, index) => (
          <EFTableCell
            key={index}
            className={`table-cell ${theme} ${valueCellClass} ${valueCellProps?.className}`}
            colSpan={index === 0 && valueCellProps?.['aria-selected'] ? 2 : 1}
            {...valueCellProps}
          >
            {item}
          </EFTableCell>
        ))
      ) : (
        <EFTableCell
          className={`table-cell ${theme} ${valueCellProps?.className}`}
          sx={{ border: !isHighlightKey ? 'none' : '' }}
          {...valueCellProps}
        >
          {value}
        </EFTableCell>
      )}
    </TableRow>
  )
}

export function EFDetailTable({ children }: IEFDetailTableProps) {
  return (
    <TableContainer>
      <Table>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  )
}
